import styles from "./index.module.css";
import CalendarStar from "./CalendarStar";
import ClockCountdown from "./ClockCountdown";
import VideoCamera from "./VideoCamera";

export default function ContentBlock() {
  return (
    <section className={styles.section} data-aos={"fade-up"}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.infoBlock}>
            <h2>КОЛИ?</h2>
            <div className={styles.list}>
              <div className={styles.row}>
                <CalendarStar />
                <span>Грудень — Лютий</span>
              </div>
              <div className={styles.row}>
                <ClockCountdown />
                <span>Пн — Чт 20:00 або 10:00</span>
              </div>
              <p>Заняття триває 60 хвилин</p>
            </div>
          </div>

          <div className={styles.divider} />

          <div className={styles.infoBlock}>
            <h2>ДЕ?</h2>
            <div className={styles.list}>
              <div className={`${styles.row} ${styles.rowBlue}`}>
                <VideoCamera />
                <span>Платформа Zoom та Edio</span>
              </div>
              <p>
                Також курс можна придбати для
                <br />
                самостійного опрацювання
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
